export default __webpack_public_path__ + "static/media/20-large.7ca474c7.jpg";